import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { Panel, Tab, Row, Col, Table } from "react-bootstrap";
import * as LotActionType from "../constants";
import Moment from "moment";
import word from "../../assets/img/file_word.png";
import excel from "../../assets/img/file_excel.png";
import pdf from "../../assets/img/file_pdf.png";
import ppt from "../../assets/img/file_pp.png";
import video from "../../assets/img/file_video.png";
import other from "../../assets/img/file_other.png";
import "../categoryModal.scss";
import TextAreaWithLinks from "../../Projects/Components/Inventory/TextAreaWithLinks";
import { getTruncatedFilename } from "../../utils/ImageConvertor";

export class InventoryItemView extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    isOpenEdit: PropTypes.func,
    closeModal: PropTypes.func,
    onDrop: PropTypes.func,
    accept: PropTypes.string,
    dispatch: PropTypes.func,
    lot: PropTypes.object,
    selectedItemtoView: PropTypes.object,
    selectedCategory: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      activeKey: "1",
      showDocumentInfo: true,
      lot: this.props.lot,
      editingState: {},
      registration: "",
      registrationImages: [],
      registrationError: "",
      uploadResults: [],
      userCareManual: "",
      userCareManualImages: [],
      userCareManualError: "",
      showBasicDetails: true,
      showItemDetail: false,
      showLinkDocument: false,
      showReceiptsotherDocs: false,
      limitedWarranty: "",
      limitedWarrantyImages: [],
      limitedWarrantyError: "",
      expandedPanels: {},
      editCategoryIndex: null,
      name: "",
      itemCategory: null,
      property: null,
      smartApp: null,
      smartAppList: [],
      locationInHome: null,
      receiptsImages: [],
      serviceContractOthersImages: [],
      generalDescription: "",
      categoryListing: [],
      propertList: null,
      typeOfPurchase: null,
      videoFile: null,
      videoPreviewUrl: "",
      videoError: "",
      previewModalOpen: false,
      previewContent: null,
      previewType: null,

      showOtherDocs: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      const { lot, selectedItemtoView } = this.props;
      if (
        !lot ||
        !lot.value ||
        !lot.extensionValue ||
        !lot.extensionValue.builderProfile
      ) {
        console.warn("Missing property or builder profile.");
        return;
      }
      this.getItemDetails();
    }
  }

  getItemDetails = () => {
    const { lot, selectedItemtoView } = this.props;
    const builderProfile = lot.extensionValue.builderProfile;

    this.props.dispatch({
      type: LotActionType.GET_ITEM_DETAIL_INVENTORY_ASYNC,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        lotId: lot.value,
        categoryId: selectedItemtoView ? selectedItemtoView.id : "",
      },
      callback: (data) => {
        this.setState({
          itemData: data.data,
        });
      },
    });
  };

  togglePanel = (panelName) => {
    this.setState((prevState) => ({
      [panelName]: !prevState[panelName],
    }));
  };

  renderFileTypeIcon = (item) => {
    const extWord = ["doc", "docx"];
    const extExcel = ["xls", "xlsx"];
    const extPpt = ["ppt", "pptx"];
    const extVideo = ["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"];
    const extImage = ["jpg", "jpeg", "png", "gif", "svg", "webp"];

    const fileName = item.fileName || item.name;
    if (!fileName) return other;

    const ext = fileName.split(".").pop().toLowerCase();

    if (extWord.includes(ext)) {
      return word;
    } else if (extExcel.includes(ext)) {
      return excel;
    } else if (extPpt.includes(ext)) {
      return ppt;
    } else if (extVideo.includes(ext)) {
      return video;
    } else if (ext === "pdf") {
      return pdf;
    } else if (extImage.includes(ext)) {
      return item.url || item.textAndUrl || other;
    } else {
      return other;
    }
  };

  getFileType = (item) => {
    if (!item) return "other";

    const fileName = item.fileName || item.name || "";
    if (!fileName) return "other";

    const ext = fileName.split(".").pop().toLowerCase();

    if (["doc", "docx"].includes(ext)) return "word";
    if (["xls", "xlsx"].includes(ext)) return "excel";
    if (["ppt", "pptx"].includes(ext)) return "ppt";
    if (["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"].includes(ext))
      return "video";
    if (ext === "pdf") return "pdf";
    if (["jpg", "jpeg", "png", "gif", "svg", "webp"].includes(ext)) return "image";
    return "other";
  };

  openPreview = (doc) => {
    const url = doc.textAndUrl || doc.url || "";
    const fileName = doc.fileName || doc.name || "";
    const fileType = this.getFileType(doc);

    this.setState({
      previewModalOpen: true,
      previewContent: {
        url,
        fileName,
        type: fileType,
      },
    });
  };

  closePreview = () => {
    this.setState({
      previewModalOpen: false,
      previewContent: null,
    });
  };

  renderLinkContent = (docs, label, key) => {
    const isValidLink = (text) => {
      if (!text) return false;
      try {
        const urlRegex = /^https?:\/\/[^\s]+$/gi;
        const isCleanUrl = urlRegex.test(text);
        if (!isCleanUrl) {
          const containsUrl = /https?:\/\/[^\s]+/gi.test(text);
          return containsUrl;
        }
        return true;
      } catch (e) {
        return false;
      }
    };

    const shouldOpenInNewTab = (doc) => {
      if (!doc) return false;
      const url = doc.textAndUrl || doc.url || "";
      if (!url) return false;
      const extension = url.split(".").pop().toLowerCase();
      const newTabExtensions = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "svg",
        "webp",
        "pdf",
        "mp4",
        "webm",
        "mov",
        "avi",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "txt",
      ]; //'numbers', 'pages'
      return newTabExtensions.includes(extension);
    };

    const textDocs = docs.filter((d) => d.docsCategory === "Text");
    const imageDocs = docs.filter(
      (d) => d.docsCategory === "Images" || !d.docsCategory
    );

    const renderTextWithLinks = (text) => {
      if (!text) return null;
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const parts = text.split(urlRegex);
      return parts.map((part, i) => 
        urlRegex.test(part) ? (
          <a key={i} href={part} target="_blank" rel="noopener noreferrer" style={{ color: "#4267b2", textDecoration: "underline" }}>{part}</a>
        ) : part
      );
    };

    return (
      <div className="form-group link-document-fields">
        {label && <label style={{ fontWeight: "bold" }}>{label}</label>}
        <div style={{ marginTop: label ? "20px" : "0" }}>
          {textDocs.map((doc, index) => (
            <div
              key={`text-${index}`}
              style={{ marginBottom: "5px", fontSize: "14px" }}
            >
              <p>{renderTextWithLinks(doc.textAndUrl || "")} </p>
            </div>
          ))}
          {imageDocs.map((doc, index) => {
            const displayText = getTruncatedFilename(doc);
            const linkContent = doc.textAndUrl || doc.url || "";
            const fileTypeIcon = this.renderFileTypeIcon(doc);
            const validLink = isValidLink(linkContent);
            const isImage = this.getFileType(doc) === "image";
            const openInNewTab = shouldOpenInNewTab(doc);

            return (
              <div key={`image-${index}`} className="item-card-content">
                {validLink && !openInNewTab ? (
                  <a
                    href={linkContent}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="item-card clickable"
                    style={{ textDecoration: "none", color: "inherit" }}
                    title={linkContent}
                  >
                    <div className="left-section">
                      {isImage ? (
                        <img
                          src={fileTypeIcon}
                          alt="file icon"
                          className="doc-icon"
                        />
                      ) : (
                        <img
                          src={fileTypeIcon}
                          alt="file icon"
                          className="doc-icon"
                        />
                      )}
                    </div>
                    {key === "mfg_images" ? (
                      ""
                    ) : (
                      <div className="middle-section">
                        <div className="doc-title">
                          <span title={displayText}>{displayText}</span>
                        </div>
                      </div>
                    )}
                  </a>
                ) : (
                  <React.Fragment>
                    {displayText && (
                      <div
                        className={`${
                          key === "mfg_images"
                            ? "item-without-text-card"
                            : "item-card"
                        } ${validLink ? "clickable" : ""}`}
                        onClick={() => {
                          if (validLink) {
                            this.openPreview(doc);
                          }
                        }}
                        style={{
                          cursor: validLink ? "pointer" : "not-allowed",
                        }}
                      >
                        <div className="left-section">
                          {isImage && validLink ? (
                            <img
                              src={fileTypeIcon}
                              alt="file icon"
                              className="doc-icon"
                            />
                          ) : (
                            <img
                              src={fileTypeIcon}
                              alt="file icon"
                              className="doc-icon"
                            />
                          )}
                        </div>
                        {key === "mfg_images" ? (
                          ""
                        ) : (
                          <div className="middle-section">
                            <div className="doc-title">
                              <span title={displayText}>{displayText}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </React.Fragment>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  renderPreviewModal = () => {
    const { previewModalOpen, previewContent } = this.state;
    if (!previewContent) return null;

    const fileExt = previewContent.url.split(".").pop().toLowerCase();
    const imageFiles = ["jpg", "jpeg", "png", "gif", "svg", "webp"];
    const videoFiles = ["mp4", "webm", "ogg", "mov", "avi"];
    const officeFiles = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];

    const renderError = (message = "Failed to load preview.") => (
      <div className="unsupported-preview">
        <p>{message}</p>
        <button
          onClick={() => window.open(previewContent.url, "_blank")}
          className="btn btn-primary"
        >
          Open in New Tab
        </button>
      </div>
    );

    const renderOfficePreview = () => {
      const officeOnlineUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        previewContent.url
      )}`;
      return (
        <iframe
          src={officeOnlineUrl}
          style={{ width: "100%", height: "70vh", border: "none" }}
          title={`Office Document Viewer - ${previewContent.fileName}`}
        />
      );
    };

    const renderPreview = () => {
      try {
        if (imageFiles.includes(fileExt)) {
          return (
            <img
              src={previewContent.url}
              alt={previewContent.fileName}
              style={{ maxHeight: "80vh", maxWidth: "100%" }}
            />
          );
        }
        if (videoFiles.includes(fileExt)) {
          return (
            <video controls style={{ maxWidth: "100%", maxHeight: "80vh" }}>
              <source src={previewContent.url} type={`video/${fileExt}`} />
              Your browser does not support the video tag.
            </video>
          );
        }
        if (fileExt === "pdf" || fileExt === "txt") {
          return (
            <div style={{ height: "70vh", width: "100%" }}>
              <iframe
                src={previewContent.url}
                title={previewContent.fileName}
                className="pdf-iframe"
                frameBorder="0"
              />
            </div>
          );
        }
        if (officeFiles.includes(fileExt)) {
          return renderOfficePreview();
        }
        // if (fileExt === 'numbers' || fileExt === 'pages') {
        //   return (
        //     // <div className="unsupported-preview">
        //     //   <p>To view this file, open it in iCloud:</p>
        //     //   <button
        //     //     onClick={() => window.open(`https://www.icloud.com/iclouddrive/${encodeURIComponent(previewContent.url)}`, '_blank')}
        //     //     className="btn btn-primary"
        //     //   >
        //     //     Open in iCloud
        //     //   </button>
        //     // </div>

        //     <div style={{ height: '70vh', width: '100%' }}>
        //       <iframe
        //         src={previewContent.url}
        //         title={previewContent.fileName}
        //         className="pdf-iframe"
        //         frameBorder="0"
        //       />
        //     </div>

        // );
        // }
        return renderError("Preview not available for this file type.");
      } catch (error) {
        return renderError();
      }
    };

    return (
      <Modal
        show={previewModalOpen}
        onHide={this.closePreview}
        centered
        className="custom-preview-modal"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{previewContent.fileName}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center", minHeight: "500px" }}>
          {renderPreview()}
        </Modal.Body>
      </Modal>
    );
  };

  checkUrlsForAndroidIOS = (doc) => {
    const isValidLink = (text) => {
      if (!text) return false;
      const urlRegex = /^https?:\/\/[^\s]+$/i;
      return urlRegex.test(text);
    };
    const linkContent = doc || "";
    const validLink = isValidLink(linkContent);
    return (
      <React.Fragment>
        {validLink ? (
          <a
            href={linkContent}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "inherit",
              textDecoration: "underline",
              color: "#4267b2",
            }}
            title={linkContent}
          >
            {linkContent}
          </a>
        ) : (
          <p>{doc}</p>
        )}
      </React.Fragment>
    );
  };

  openEditModal = () => {
    const { itemData } = this.state;
    const { isOpenEdit, closeModal } = this.props;
    isOpenEdit(itemData.id);
    closeModal();
  };

  render() {
    const {
      itemData,
      showBasicDetails,
      showItemDetail,
      showLinkDocument,
      showReceiptsotherDocs,
      showOtherDocs,
    } = this.state;
    const { isOpen, closeModal, lot } = this.props;
    console.log("itemData in view modal:", itemData);
    return (
      <div>
        <Modal
          show={isOpen}
          onHide={closeModal}
          backdrop="static"
          dialogClassName="slide-in-modal"
          className="modal-right"
        >
          <Modal.Header className="modal-header-profile">
            <div className="modal-header">
              <i
                className="fa fa-chevron-left arrow-btn"
                aria-hidden="true"
                onClick={closeModal}
              ></i>
              <Modal.Title className="modal-title-custom">
                View Item
              </Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body className="modal-body-add-doc scrollable-modal-body">
            {itemData ? (
              <div>
                <div className="image-upload-section">
                  <div style={{ width: "100%" }}>
                    {this.renderLinkContent(itemData.images, "", "mfg_images")}
                  </div>
                </div>

                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row className="clearfix">
                    <Col sm={12}>
                      <Tab.Content animation className="add-inventory-item">
                        <Tab.Pane eventKey="first">
                          <Panel>
                            <Panel.Heading
                              onClick={() =>
                                this.togglePanel("showBasicDetails")
                              }
                            >
                              <div className="accordion-header">
                                <span>
                                  <span
                                    className={`glyphicon arrow-icon ${
                                      showBasicDetails
                                        ? "glyphicon-chevron-up"
                                        : "glyphicon-chevron-down"
                                    }`}
                                  ></span>{" "}
                                  <span className="lot-titles">
                                    Basic Details
                                  </span>
                                </span>
                              </div>
                            </Panel.Heading>
                            {showBasicDetails && (
                              <Panel.Body>
                                <Table bordered className="accordion-table-doc">
                                  <tbody>
                                    <tr>
                                      <th>Name</th>
                                      <td>{itemData.name}</td>
                                    </tr>
                                    <tr>
                                      <th>Property</th>
                                      <td>
                                        <span>{lot.text}</span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th>Category</th>
                                      <td>{itemData.category.name}</td>
                                    </tr>
                                    <tr>
                                      <th>General Description</th>
                                      <td>
                                        <TextAreaWithLinks
                                          initialValue={itemData.description}
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </Panel.Body>
                            )}
                          </Panel>

                          <Panel>
                            <Panel.Heading
                              onClick={() => this.togglePanel("showItemDetail")}
                            >
                              <div className="accordion-header">
                                <span>
                                  <span
                                    className={`glyphicon arrow-icon ${
                                      showItemDetail
                                        ? "glyphicon-chevron-up"
                                        : "glyphicon-chevron-down"
                                    }`}
                                  ></span>
                                  <span className="lot-titles">
                                    Item Details
                                  </span>
                                </span>
                              </div>
                            </Panel.Heading>
                            {showItemDetail && (
                              <Panel.Body>
                                <Table bordered className="accordion-table-doc">
                                  <tbody>
                                    <tr>
                                      <th>MFG Name / Vendor</th>
                                      <td>{itemData.mfgName}</td>
                                    </tr>
                                    <tr>
                                      <th>Model #</th>
                                      <td>{itemData.modelNo}</td>
                                    </tr>
                                    <tr>
                                      <th>Serial #</th>
                                      <td>
                                        <div>
                                          {itemData.serialNo}
                                          {itemData.serialNoImage && (
                                            <div style={{ marginTop: "10px" }}>
                                              {this.renderLinkContent(
                                                [itemData.serialNoImage],
                                                "",
                                                "serial_images"
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th>Location in Home</th>
                                      <td>
                                        <div>
                                          {itemData.locationInHome}
                                          {itemData.video &&
                                          itemData.video.length ? (
                                            <div style={{ marginTop: "10px" }}>
                                              {/* {this.renderLinkContent(
                                                itemData.video,
                                                "Video",
                                                ""
                                              )} */}
                                              {this.renderLinkContent(
                                                itemData.video,
                                                "",
                                                ""
                                              )}
                                            </div>
                                          ) : null}
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th>Purchase Date</th>
                                      <td>
                                        {itemData.purchaseDate
                                          ? Moment(
                                              itemData.purchaseDate
                                            ).format("MM/DD/YYYY")
                                          : null}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th>Price</th>
                                      <td>{itemData.price}</td>
                                    </tr>
                                    <tr>
                                      <th>Type of Purchase</th>
                                      <td>{itemData.typeofPurchase}</td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </Panel.Body>
                            )}
                          </Panel>
                          <Panel>
                            <Panel.Heading
                              onClick={() =>
                                this.togglePanel("showLinkDocument")
                              }
                            >
                              <div className="accordion-header">
                                <span>
                                  <span
                                    className={`glyphicon arrow-icon ${
                                      showLinkDocument
                                        ? "glyphicon-chevron-up"
                                        : "glyphicon-chevron-down"
                                    }`}
                                  ></span>
                                  <span className="lot-titles">
                                    Link & Documents
                                  </span>
                                </span>
                              </div>
                            </Panel.Heading>
                            {showLinkDocument && (
                              <Panel.Body>
                                <Table bordered className="accordion-table-doc">
                                  <tbody>
                                    <tr>
                                      <td colSpan="2">
                                        <div className="form-group link-document-fields">
                                          {this.renderLinkContent(
                                            itemData.registrationManual,
                                            "Registration",
                                            ""
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan="2">
                                        <div className="form-group link-document-fields">
                                          {this.renderLinkContent(
                                            itemData.userCareManual,
                                            "User & Care Manual",
                                            ""
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td colSpan="2">
                                        <div className="form-group link-document-fields">
                                          {this.renderLinkContent(
                                            itemData.limitedWarranty,
                                            "Limited Warranty",
                                            ""
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th>Warranty Start</th>
                                      <td>
                                        {itemData.warrantyStartDate
                                          ? Moment(
                                              itemData.warrantyStartDate
                                            ).format("MM/DD/YYYY")
                                          : null}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th>Warranty End</th>
                                      <td>
                                        {itemData.warrantyEndDate
                                          ? Moment(
                                              itemData.warrantyEndDate
                                            ).format("MM/DD/YYYY")
                                          : null}
                                      </td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </Panel.Body>
                            )}
                          </Panel>

                          <Panel>
                            <Panel.Heading
                              onClick={() =>
                                this.togglePanel("showReceiptsotherDocs")
                              }
                            >
                              <div className="accordion-header">
                                <span>
                                  <span
                                    className={`glyphicon arrow-icon ${
                                      showReceiptsotherDocs
                                        ? "glyphicon-chevron-up"
                                        : "glyphicon-chevron-down"
                                    }`}
                                  ></span>
                                  <span className="lot-titles">
                                    Receipts & Other Docs
                                  </span>
                                </span>
                              </div>
                            </Panel.Heading>
                            {showReceiptsotherDocs && (
                              <Panel.Body>
                                <div>
                                  <div style={{ marginTop: "20px" }}>
                                    {this.renderLinkContent(
                                      itemData.receipts,
                                      "Receipts",
                                      ""
                                    )}
                                  </div>
                                </div>
                                <div>
                                  {this.renderLinkContent(
                                    itemData.serviceContracts,
                                    "Service Contract & Others",
                                    ""
                                  )}
                                </div>
                              </Panel.Body>
                            )}
                          </Panel>

                          {itemData.others && itemData.others.length ? (
                            <Panel>
                              <Panel.Heading
                                onClick={() =>
                                  this.togglePanel("showOtherDocs")
                                }
                              >
                                <div className="accordion-header">
                                  <span>
                                    <span
                                      className={`glyphicon arrow-icon ${
                                        showOtherDocs
                                          ? "glyphicon-chevron-up"
                                          : "glyphicon-chevron-down"
                                      }`}
                                    ></span>
                                    <span className="lot-titles">Other</span>
                                  </span>
                                </div>
                              </Panel.Heading>
                              {showOtherDocs && (
                                <Panel.Body>
                                  <div style={{ marginTop: "20px" }}>
                                    {this.renderLinkContent(
                                      itemData.others,
                                      "",
                                      ""
                                    )}
                                  </div>
                                </Panel.Body>
                              )}
                            </Panel>
                          ) : (
                            ""
                          )}

                          <div className="smart-app-section">
                            <div className="title">SMART App</div>
                            <Table bordered className="accordion-table-doc">
                              <tbody>
                                <tr>
                                  <th>App Name</th>
                                  <td>
                                    {itemData.smartApp
                                      ? itemData.smartApp.appName
                                      : ""}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Android URL</th>
                                  <td>
                                    <div>
                                      {this.checkUrlsForAndroidIOS(
                                        itemData.smartApp
                                          ? itemData.smartApp.androidUrl
                                          : ""
                                      ) || null}
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <th>iOS URL</th>
                                  <td>
                                    <div>
                                      {this.checkUrlsForAndroidIOS(
                                        itemData.smartApp
                                          ? itemData.smartApp.iosUrl
                                          : ""
                                      ) || null}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            ) : (
              ""
            )}
          </Modal.Body>
          <Modal.Footer className="modal-footer-addDocument">
            <button
              type="button"
              onClick={this.openEditModal}
              className="save-doc-btn"
            >
              <span
                className="fa fa-pencil "
                style={{
                  color: "#ffffff",
                  marginRight: 6,
                }}
              />
              Edit Item
            </button>
          </Modal.Footer>
        </Modal>
        {this.renderPreviewModal()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    LotDocuments: state.LotStore.LotDocuments,
  };
};

export default connect(mapStateToProps)(InventoryItemView);



// WEBPACK FOOTER //
// ./src/Lots/Components/inventoryItemView.js